import React from 'react'
import reactStringReplace from 'react-string-replace'

import { OutlineButton } from '../buttons/Buttons'
import Icon from '../icon/Icon'
import { LinkText, Text } from '../topography'
import { palette } from '../../styles/variables'
import whiteScreenAlert from '../../styles/assets/white_screen_alert.svg'
import reloadIcon from '../../styles/assets/reload.svg'
import { translate } from '../../utils/translation'

import Modal, { ModalHeader, ModalContent, ModalFooter } from './Modal'

const desktopStyle = {}

const mobileStyle = {
  width: '100%',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
}

export default ({ isOpen, ...rest }) => (
  <Modal
    isOpen={isOpen}
    desktopStyle={desktopStyle}
    mobileStyle={mobileStyle}
    {...rest}
  >
    <ModalHeader>
      <Icon src={whiteScreenAlert} />
      <Text
        fontSize="16px"
        lineHeight="28px"
        margin="16px 0 0 0"
        textAlign="center"
        dangerouslySetInnerHTML={{
          __html: translate('general_error_page_message'),
        }}
        boldColor={palette.darkGray}
      />
    </ModalHeader>
    <ModalContent style={{ height: 'calc(100% - 200px)' }}>
      <Text lineHeight="24px" margin="16px 0 0 0" textAlign="center">
        {reactStringReplace(
          translate('if_issue_persists', translate('support_email')),
          translate('support_email'),
          (match, i) => {
            return (
              <LinkText
                target="_blank"
                key={`privacy-${i}`}
                href="mailto:support@ubersuggest.com"
              >
                {match}
              </LinkText>
            )
          },
        )}
      </Text>
    </ModalContent>
    <ModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
      <OutlineButton
        static
        style={{
          width: 'fit-content',
          height: '40px',
          flex: 'inherit',
          fontSize: '14px',
          letterSpacing: '0.08em',
          padding: '14px 56px',
          marginTop: '24px',
        }}
        onClick={() => {
          window.location.reload()
        }}
      >
        <Icon src={reloadIcon} margin="0 8px 0 0" />
        {translate('refresh_button')}
      </OutlineButton>
    </ModalFooter>
  </Modal>
)
